import React from 'react';
import PropTypes from 'prop-types';
//import { Link } from 'react-router-dom';
import AttachFile from '@material-ui/icons/AttachFile';
import Close from '@material-ui/icons/Close';
import intl from 'react-intl-universal';
import isEmpty from 'lodash.isempty';
import { formatDateTime } from 'src/helpers/date';
import { MESSAGEBOX_TYPES } from 'src/constants/constants';
import UploadView from 'src/ui/library/Upload/UploadViewContainer';
import { MessageDetailsActionsPres } from 'src/ui/features/Messaging/presentational';
import Autocomplete from 'src/ui/library/Autocomplete';
import PriorityHigh from '@material-ui/icons/PriorityHigh';

export default function ViewMsgPres({
  isCaseMessages,
  isComposeView,
  isCorpClient,
  isMobile,
  messageData,
  selectedMenu,
  onCancel,
  onReply,
  onReplyToAll,
  onForward,
  showConfirm,
  caseSelected,
  onFieldUpdate,
  onRequestCases,
  handleAssignToCase,
  downloadAttachment,
  isApplicant,
  isEyPro,
}) {
  const attachmentMenu = [
    {
      key: `${intl.get('messaging.attachmentMenu.download')}`,
      icon: `${intl.get('messaging.attachmentMenu.cloudDownload')}`,
      text: `${intl.get('messaging.attachmentMenu.download')}`,
      handler: downloadAttachment,
    },
  ];

  return (
    <div className="messaging-detail viewmsg">
      {isMobile && !isComposeView && (
        <div className="compose-mobile-wrapper">
          <Close className="mobile-close" onClick={onCancel} />
        </div>
      )}
      {messageData && !isEmpty(messageData) && (
        <div className="detail">
          <header className="detail-header">
            <MessageDetailsActionsPres
              selectedMenu={selectedMenu}
              isCaseMessages={isCaseMessages}
              onReply={onReply}
              onReplyToAll={onReplyToAll}
              onForward={onForward}
              showConfirm={showConfirm}
              messageData={messageData}
              isApplicant={isApplicant}
              isCorpClient={isCorpClient}
              isEyPro={isEyPro}
            />
            <h1 className="detail-title">{messageData.subject}</h1>
            <div className="detail-date">
              {messageData.priority === 'High' && (
                <React.Fragment>
                  <span className={'high-priority'}>{intl.get('messaging.compose.highPriority')}</span>
                  <PriorityHigh className="priority-high" />
                </React.Fragment>
              )}
              {messageData.hasAttachment && <AttachFile className="icon sm" />}
              {formatDateTime(messageData.sentOn)}
            </div>
            <p>
              {messageData.from.length && intl.get('messaging.details.from')}:{' '}
              <span className="detail-value">
                {messageData.from[0].name} (<a href={`mailto:${messageData.from[0].email}`}>{messageData.from[0].email}</a>)
              </span>
            </p>
            {messageData.to && messageData.to.length > 0 && (
              <p>
                {`${intl.get('messaging.details.to')}: `}
                {messageData.to.map((item, index, arr) => {
                  return (
                    <span className="detail-toemail" key={index}>
                      <span className="detail-value">
                        {item.name} (<a href={`mailto:${item.email}`}>{item.email}</a>){index === arr.length - 1 ? '' : ','}
                      </span>
                    </span>
                  );
                })}
              </p>
            )}
            {messageData.cc && messageData.cc.length > 0 && (
              <p>
                {`${intl.get('messaging.details.cc')}: `}
                {messageData.cc.map((item, index, arr) => {
                  return (
                    <span className="detail-ccemail" key={index}>
                      <span className="detail-value">
                        {item.name} (<a href={`mailto:${item.email}`}>{item.email}</a>){index === arr.length - 1 ? '' : ','}
                      </span>
                    </span>
                  );
                })}
              </p>
            )}

            {selectedMenu === MESSAGEBOX_TYPES.INBOX && (
              <div className={'compose-input-wrapper'}>
                {!caseSelected && (
                  <p>
                    {messageData.caseDetails &&
                      intl.get('messaging.details.case') +
                        ': ' +
                        messageData.caseDetails.caseName +
                        ' - ' +
                        messageData.caseDetails.engagement}
                  </p>
                )}
                {caseSelected && (
                  <span>
                    <span className="case-assign">
                      <Autocomplete
                        label={`${intl.get('messaging.compose.case')}:`}
                        styleType="emailCases"
                        multi={false}
                        defaultValue={messageData.caseDetails}
                        onFilter={(row, val) => {
                          const { engagement, caseName } = row.data;
                          const arr = [engagement, caseName];
                          return arr.some(item => item && val && item.toLowerCase().includes(val.toLowerCase()));
                        }}
                        onChange={val => onFieldUpdate('caseId', val ? val.caseId : '')}
                        loadOptions={onRequestCases}
                        getOptionValue={row => row}
                      />
                    </span>
                    <span>
                      <a className="message-link" key="assignToCase" onClick={handleAssignToCase}>
                        {intl.get('messaging.details.assignToCase')}
                      </a>
                    </span>
                  </span>
                )}
              </div>
            )}
            {selectedMenu === MESSAGEBOX_TYPES.SENT && (
              <div className={'compose-input-wrapper'}>
                <p>
                  {messageData.caseDetails &&
                    intl.get('messaging.details.case') +
                      ': ' +
                      messageData.caseDetails.caseName +
                      ' - ' +
                      messageData.caseDetails.engagement}
                </p>
              </div>
            )}
          </header>
          <UploadView attachments={messageData.attachments} menu={attachmentMenu} />
          <div className="detail-body" dangerouslySetInnerHTML={{ __html: messageData.body }} />
        </div>
      )}
    </div>
  );
}

ViewMsgPres.propTypes = {
  meta: PropTypes.object.isRequired,
  messages: PropTypes.array.isRequired,
  showConfirm: PropTypes.func.isRequired,
  onForward: PropTypes.func.isRequired,
  onReply: PropTypes.func.isRequired,
  onReplyToAll: PropTypes.func.isRequired,
  isEyPro: PropTypes.bool.isRequired,
};
